export const KOT_TYPE = {
  DINE: 1,
};
